import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageSchoolUiModule } from '@digilize/language-school/ui';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';

import { ExerciseExamResultComponent } from './exercises/exercise-exam-result/exercise-exam-result.component';
import { TextExerciseComponent } from './exercises/exercise-text/text-exercise.component';
import { ExercisesComponent } from './exercises/exercises.component';
import { OrderExerciseComponent } from './exercises/order-exercise/order-exercise.component';
import { ResultComponent } from './exercises/result/result.component';
import { SingleExerciseComponent } from './exercises/single-exercise/single-exercise.component';
import { TextDialogComponent } from './exercises/text-dialog/text-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';
import { SafePipeModule } from 'safe-pipe';

const COMPONENTS = [
  ExercisesComponent,
  TextExerciseComponent,
  SingleExerciseComponent,
  OrderExerciseComponent,
  ResultComponent,
  ExerciseExamResultComponent,
  TextDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedUiComponentsModule,
    SharedFeatureComponentsModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    LanguageSchoolUiModule,
    SharedUiMaterialModule,
    SafePipeModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class LanguageSchoolFeatureExercisesModule {}
